export const moduleId = 'sale-collection';

export const state = {
    lists: {},//详情参数
    orglist: [],//账套列表
    costIsShow: false,//详情显示隐藏
    dialogzt: false,//账套显示隐藏
    flag: false,//是否可编辑
    orgId: '',
    isShow: true,
    id: '',
    isDeapproval: false,
    isRouter: false,
    routeSource: false,
    isAdd: true,
    abId: '',
    orderNo: '',
    customerList:[]
}
export const mutations = {
    setSaleIsAdd(state, flag) {
        state.isAdd = flag
    },
    // setSaleOrgId(state, id) {
    //     state.orgId = id
    // },
    // setSaleTaskId(state, data) {
    //     state.id = data.id
    //     state.abId = data.abId
    // },
    //反审批
    setSaleIsDeapproval(state, data) {
        state.isDeapproval = data
    },
    setSaleRouteSource(state, data) {
        state.routeSource = data
    },
    setSaleCostIsShow(state, data) {
        state.costIsShow = data
    },
    setSaleDialogzt(state, data) {
        state.dialogzt = data
    },
    setSaleOrgList(state, data) {
        state.lists = data
    },
    //账套列表
    setOrgList(state, data) {
        state.orglist = data
    },
    setSaleFalg(state, data) {
        state.flag = data
    },
    setSaleIsRouter(state, data) {
        state.isRouter = data
    },
    setOrderNo(state, data) {
        state.orderNo = data
    },
    setCustomerList(state, data) {
        state.customerList = data
    }
}
export const actions = {}


// WEBPACK FOOTER //
// ./src/store/modules/settlement-center/sale-collection/index.js